import drockerhofLogoSmall from '../assets/drockerhof-logo-small.svg'

const BlogPost = ({ title, subtitle, body, images }) => {
    const replacePlaceholders = (text, images) => {
        let replacedText = text ? text : ''

        if ((images !== undefined) && (images.length > 0))
            images.forEach((image, index) => {
                // Replace %image{index + 1}% with actual image component
                const altText = image.alt ? image.alt : `Image ${index + 1}`
                replacedText = replacedText.replace(new RegExp(`%image${index + 1}%`, 'g'), `<img class="drocker-blog-image drocker-blog-image-${image.size}" src="${image.url}" alt="${altText}" />`)
            })

        return <p dangerouslySetInnerHTML={{ __html: replacedText }} />
    }

    return (
        <div className="card mb-3">
            <div className="card-body">
                {title && <h2 className="card-title">{title}</h2>}
                {subtitle && <h3 className="card-subtitle mb-2 text-body-secondary">{subtitle}</h3>}
                <div className="card-text text-center">{replacePlaceholders(body, images)}</div>
                <div className="text-center mt-3">
                    <img src={drockerhofLogoSmall} alt="Drockerhof Logo" width="120" height="46" className="d-inline-block align-text-top" loading="lazy" />
                </div>
            </div>
        </div>
    )
}

export default BlogPost
